
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.833 2.5H4.167c-.925 0-1.667.75-1.667 1.667v11.666c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.742-1.667-1.667-1.667zm0 13.333H4.167v-10h11.666v10zM13.333 10H6.667a.836.836 0 01-.834-.833c0-.459.375-.834.834-.834h6.666c.459 0 .834.375.834.834a.836.836 0 01-.834.833zM10 13.333H6.667a.836.836 0 01-.834-.833c0-.458.375-.833.834-.833H10c.458 0 .833.375.833.833a.836.836 0 01-.833.833z"}})])
          )
        }
      }
    